import React from 'react'

import { Box } from 'widgets/Box'
import { Modal } from 'widgets/Modal'
import { Text } from 'widgets/Text'

import { usePost } from 'hooks/usePost'

import { Toast } from 'utils/toast'

interface DeletePostModalProps {
  handleClose: (wasPostDeleted?: boolean) => void
  isOpen: boolean
  postId: string
}

export const DeletePostModal = ({
  handleClose,
  isOpen,
  postId,
}: DeletePostModalProps): JSX.Element => {
  const { deletePost } = usePost(postId)

  if (!isOpen) return <></>

  const handleDelete = async () => {
    deletePost.mutate()
    handleClose(true)
    Toast.success(
      'Post Deleted',
      'The post has successfully been deleted.',
      undefined,
      undefined,
      true,
      'bottom',
      undefined,
      undefined,
      true,
    )
  }

  const handleCancel = () => {
    handleClose(false)
  }

  return (
    <Modal
      actionButtonProps={[
        {
          title: 'Cancel',
          onPress: handleCancel,
          type: 'grey',
        },
        {
          title: 'Delete',
          onPress: handleDelete,
          type: 'v2primary',
        },
      ]}
      isVisible={isOpen}
      onClose={handleCancel}
      title='Delete post'
    >
      <Box padding={{ vertical: 'lg' }}>
        <Text fontSize='sm' align='center'>
          Are you sure you wish to delete this post?
        </Text>
      </Box>
    </Modal>
  )
}
